export default __webpack_public_path__ + "img/4b53df0513c034e3ef28de1a205f3503.png";